import WalletAddressList from "./WalletAddressList";
import AppsContainer from "@lib/components/AppComponents/AppsContainer";
import Sidebar from "./Sidebar";
import { useIntl } from "react-intl";
import { SharedContextProps } from "@lib/types";
import { ROUTES } from "@lib/constants";
import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { apiGetSendByteWallets } from "@lib/api/walletSendByte";
import { useParamsManager } from "@lib/hooks/useParamsManager";

const SharedWalletAddressSendByteList: React.FC<SharedContextProps> = ({
  context,
  detailContext,
  customerId,
  leadId,
  customTitle,
  withoutContainer = false,
  withoutBreadcrumb,
  withoutSidebar = false,
  pageIsActive = true,
}) => {
  const { messages } = useIntl();
  const { walletId } = useParams();
  const _withoutSidebar = withoutSidebar || withoutContainer || !pageIsActive;

  const filter = [].concat(
    ...(customerId ? [`customerId||$eq||${customerId}`] : []),
  );

  const { params } = useParamsManager({
    page: 1,
    limit: 100,
    sort: "createdAt,DESC",
    filter: filter,
    join: ["customer"],
    isShowParamsInUrl: false,
  });

  const sendByteWalletsQuery = useQuery({
    queryFn: () => apiGetSendByteWallets(params),
    queryKey: ["sendbyte-wallets", JSON.stringify(params)],
    enabled: !!params && !!pageIsActive && !_withoutSidebar,
  });
  const { data } = sendByteWalletsQuery;
  const apiData = data?.data?.data;

  const walletIdProp = useMemo(() => {
    const find = apiData?.find((w) => w.id === walletId);
    return find?.name || "";
  }, [walletId, apiData]);

  // Context-specific title and breadcrumb
  const title =
    customTitle || (messages["common.sendByteWalletAccounts"] as string);

  return (
    <AppsContainer
      noContainer={!!withoutContainer}
      title={title}
      breadcrumbProps={{
        urlParams: {
          [ROUTES.URL_PARAMS.WALLET_ID]: walletIdProp,
        },
      }}
      cardProps={{
        borderFull: true,
        coloredHeader: true,
      }}
      showBreadcrumb={!withoutBreadcrumb}
      sidebarContent={
        !withoutSidebar ? (
          <AppsContainer.SidebarCard>
            <Sidebar
              sendByteWalletsQuery={sendByteWalletsQuery}
              context={context}
              customerId={customerId}
              leadId={leadId}
            />
          </AppsContainer.SidebarCard>
        ) : null
      }
    >
      <WalletAddressList
        sendByteWalletsQuery={sendByteWalletsQuery}
        context={context}
        detailContext={detailContext}
        customerId={customerId}
        leadId={leadId}
        pageIsActive={pageIsActive}
      />
    </AppsContainer>
  );
};

export default SharedWalletAddressSendByteList;
